/* global axios */
import ApiClient from './ApiClient';

class TalkviaFactaOfflineBatchesAPI extends ApiClient {
  constructor() {
    super('talkvia_facta_offline_batches', { accountScoped: true });
  }

  get(params = {}) {
    return axios.get(this.url, { params });
  }

  show(id, params = {}) {
    return axios.get(`${this.url}/${id}`, { params });
  }

  audience(labelTitles) {
    return axios.get(`${this.url}/audience`, {
      params: { label_titles: labelTitles },
    });
  }

  integration() {
    return axios.get(`${this.url}/integration`);
  }

  create(data) {
    return axios.post(this.url, data, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  }

  download(id, resultStatus = 'all') {
    return axios.get(`${this.url}/${id}/download`, {
      responseType: 'blob',
      params: { result_status: resultStatus },
    });
  }

  pause(id) {
    return axios.post(`${this.url}/${id}/pause`);
  }

  resume(id) {
    return axios.post(`${this.url}/${id}/resume`);
  }

  cancel(id) {
    return axios.post(`${this.url}/${id}/cancel`);
  }

  retryResult(id, resultId) {
    return axios.post(`${this.url}/${id}/results/${resultId}/retry`);
  }

  destroy(id) {
    return axios.delete(`${this.url}/${id}`);
  }

  downloadUrl(id) {
    return `${this.url}/${id}/download`;
  }
}

export default new TalkviaFactaOfflineBatchesAPI();
